export const dailyChest = {
  title: "Daily Chests",
  newCampaign: "สร้างแคมเปญ",
  editCampaign: "แก้ไขแคมเปญ",
  name: "ชื่อ",
  startDate: "วันเริ่ม",
  endDate: "วันสิ้นสุด",
  datePlaceholder: "วัน/เดือน/ปี (DD/MM/YYYY)",
  detail: "คำอธิบายแคมเปญ",
  detailHint: "ข้อความที่ผู้เล่นจะเห็น (ไม่บังคับ)",
  campaignImage: "รูปแคมเปญ",
  campaignImageHint: "รูปที่ผู้เล่นจะเห็น (ไม่บังคับ)",
  removeImage: "ลบรูป",
  status: "สถานะ",
  live: "ใช้งาน",
  draft: "ฉบับร่าง",
  statusScheduled: "กำลังจะเริ่ม",
  statusEnded: "สิ้นสุดแล้ว",
  statusOff: "ปิดอยู่",
  actions: "จัดการ",
  edit: "Edit",
  publish: "เผยแพร่",
  published: "เผยแพร่แล้ว",
  milestones: "รางวัลตามจำนวนครั้งที่เช็คอิน",
  addChest: "เพิ่มหีบ",
  collapseAll: "ย่อทั้งหมด",
  expandAll: "ขยายทั้งหมด",
  loginCountPrefix: "เช็คอินครบ",
  loginCountSuffix: "ครั้ง",
  loginCountLabel: "จำนวนครั้งที่เช็คอิน",
  chestName: "ชื่อหีบ",
  imageUrl: "รูปหีบ",
  clickToUpload: "คลิกเพื่ออัปโหลดรูป",
  imageUploaded: "อัปโหลดแล้ว — คลิกเพื่อเปลี่ยน",
  upload: "อัปโหลด",
  uploadFailed: "อัปโหลดรูปไม่สำเร็จ",
  removeChest: "ลบหีบ",
  rewardPool: "รางวัลในหีบ",
  reward: "รางวัล (เป็นสตางค์)",
  turnover: "เทิร์น (เป็นสตางค์)",
  turnoverHint: "กรอกเป็นสตางค์ (฿1 = 100), เทิร์น = ยอดที่ผู้เล่นต้องเล่นให้ครบก่อนถอนรางวัลนี้ได้ (กันรับรางวัลแล้วถอนทันที), ใส่ 0 = ถอนได้ทันที",
  dropRate: "โอกาสออก",
  addReward: "เพิ่มรางวัล",
  fillRemainder: "เติมส่วนที่เหลือ",
  dropHint: "ยิ่งโอกาสออกสูง ยิ่งออกบ่อย",
  poolTitle: "รางวัลในหีบ",
  poolExplainer: "หีบนี้สุ่มออก 1 รางวัลตามโอกาสที่ตั้ง, โอกาสรวมทุกรางวัลต้อง = 100%",
  poolSumLabel: "รวมโอกาส",
  rewardsUnit: "รางวัล",
  save: "บันทึกแคมเปญ",
  cancel: "ยกเลิก",
  noCampaigns: "ยังไม่มีแคมเปญ",
  noPermission: "ไม่มีสิทธิ์ (DAILY_CHEST.MANAGE)",
  publishConfirmTitle: "เผยแพร่แคมเปญ",
  publishConfirmMessage: "แคมเปญนี้จะเริ่มใช้งานและแทนที่แคมเปญที่ใช้งานอยู่",
  publishSupersede: "จะแทนที่แคมเปญที่ใช้งานอยู่:",
  publishNoActive: "จะเริ่มใช้งานทันที (ยังไม่มีแคมเปญที่ใช้งานอยู่)",
  saved: "บันทึกแล้ว",
  publishedToast: "เผยแพร่แล้ว",
  loadFailed: "โหลดไม่สำเร็จ",
  saveFailed: "บันทึกไม่สำเร็จ",
  publishFailed: "เผยแพร่ไม่สำเร็จ",
  inactivate: "ปิดใช้งาน",
  inactivateConfirmTitle: "ปิดแคมเปญ",
  inactivateConfirmMessage: "แคมเปญนี้จะถูกปิด — ผู้เล่นจะไม่มีหีบเช็คอินให้เล่นจนกว่าจะเผยแพร่แคมเปญอื่น",
  inactivatedToast: "ปิดแล้ว",
  inactivateFailed: "ปิดไม่สำเร็จ",
  sumMustBe100: "ผลรวมโอกาสออกต้องเท่ากับ 100",
  atLeastOneReward: "แต่ละหีบต้องมีรางวัลอย่างน้อย 1",
  amountPositive: "จำนวนรางวัลต้องมากกว่า 0",
  dropPositive: "โอกาสออกต้องมากกว่า 0",
  nameRequired: "ต้องระบุชื่อแคมเปญ",
  datesRequired: "ต้องระบุวันเริ่มและวันสิ้นสุด",
  endAfterStart: "วันสิ้นสุดต้องไม่ก่อนวันเริ่ม",
  addAtLeastOneChest: "ต้องเพิ่มหีบอย่างน้อย 1 หีบ",
  chestNotReady: "ยังมีรางวัลที่เป็น 0 สตางค์ (ต้องมากกว่า 0)",
  confirm: "ยืนยัน",
  discardConfirm: "ยกเลิกการแก้ไข? ข้อมูลที่ยังไม่บันทึกจะหาย",
  removeChestConfirm: "ลบหีบนี้? การตั้งค่ารางวัลในหีบจะหาย",
  chestsUnit: "หีบ",
  allChestsReady: "ทุกหีบพร้อม",
  notReadySuffix: "ยังไม่พร้อม",
  fixErrors: "กรุณาแก้ข้อมูลที่ทำเครื่องหมายไว้",
};
